import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M11.318 16.93v-.001a112.75 112.75 0 0 0-2.418-2.17l-.455-.401c-.852-.752-1.577-1.406-2.17-2.032C5.102 11.084 4.5 10.006 4.5 8.604 4.5 6.29 6.263 4.5 8.488 4.5c1.264 0 2.488.606 3.287 1.569l.385.463.385-.463c.8-.963 2.023-1.569 3.287-1.569 2.225 0 3.988 1.79 3.988 4.104 0 1.402-.6 2.48-1.776 3.724-.592.626-1.317 1.28-2.169 2.034l-.447.394a112.618 112.618 0 0 0-2.426 2.182l-.84.78-.844-.788Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "heart"}) } }